import { connect } from 'react-redux';
import actions from '../../../redux/modules/user';
import screen from './Profile';

const mapStateToProps = state => ({
  user: state.user.data,
});

const mapDispatchToProps = dispatch => ({
  loadUser() {
    dispatch(actions.receiveUserData());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(screen);



// WEBPACK FOOTER //
// ./src/screens/client/profile/index.js